export const GET_STUDENT_GOALS = 'GET_STUDENT_GOALS';
export const GET_STUDENT_GOALS_SUCCESS = 'GET_STUDENT_GOALS_SUCCESS';
export const GET_STUDENT_GOALS_FAIL = 'GET_STUDENT_GOALS_FAIL';
export const GET_STUDENT_GOALS_DOWNLOAD = 'GET_STUDENT_GOALS_DOWNLOAD';

export const SAVE_STUDENT_GOALS = 'SAVE_STUDENT_GOALS';
export const SAVE_STUDENT_GOALS_SUCCESS = 'SAVE_STUDENT_GOALS_SUCCESS';
export const SAVE_STUDENT_GOALS_FAIL = 'SAVE_STUDENT_GOALS_FAIL'